import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Segment,
  Dimmer,
  Loader,
  Dropdown,
  Modal,
  Button,
  Input,
  Image,
  Transition,
} from 'semantic-ui-react';
import { TimePicker } from 'material-ui-time-picker';
import Immutable from 'seamless-immutable';
import { userActions } from '../../actions/index';
import Strings from '../../common/Strings';
import Constant from '../../common/Constant';
import '../Common.css';
import './SettingsProfile.css';
import { getCurrencyText } from '../../helpers/currency';
import { capitalize } from '../../helpers/string';
import Analytics from '../../analytics/Analytics';
import Events from '../../analytics/Events';

const moment = require('moment');

const DayOption = ({ id, active, label, onClick }) => {
  const className = active
    ? 'day-option-container active'
    : 'day-option-container';
  const textClassName = active ? 'day-option-text active' : 'day-option-text';
  return (
    <button id={id} className={className} onClick={onClick}>
      <p className={textClassName}>{label}</p>
    </button>
  );
};

DayOption.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

class SettingsProfile extends React.Component {
  static arraysEqual(_arr1, _arr2) {
    if (
      !Array.isArray(_arr1) ||
      !Array.isArray(_arr2) ||
      _arr1.length !== _arr2.length
    ) {
      return false;
    }

    const arr1 = _arr1.concat().sort();
    const arr2 = _arr2.concat().sort();

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  static getIncrementText(minutes) {
    if (minutes === 5) {
      return Strings.SETTINGS.increment5Minutes;
    } else if (minutes === 15) {
      return Strings.SETTINGS.increment15Minutes;
    } else if (minutes === 30) {
      return Strings.SETTINGS.increment30Minutes;
    }
    return Strings.SETTINGS.increment60Minutes;
  }

  constructor(props) {
    super(props);

    this.state = {
      displayName: this.props.displayName,
      alertInterval: this.props.alertInterval,
      alertDays: this.props.alertDays,
      alertStartingAt: this.props.alertStartingAt,
      alertEndingAt: this.props.alertEndingAt,
      alertEnabled: this.props.alertEnabled,
      alertIncrementMinutes: this.props.alertIncrementMinutes,
      defaultCurrency: this.props.defaultCurrency,
      startingAtOpen: false,
      untilOpen: false,
      deleteModalOpen: false,
    };
  }

  onNameInput = (e, { value }) => {
    this.setState({ displayName: capitalize(value) });
  };

  onPressDay(day) {
    const oldValue = this.state.alertDays;
    let newValue = Immutable.asMutable(oldValue);

    if (oldValue.indexOf(day) !== -1) {
      for (let i = newValue.length; i--; ) {
        if (newValue[i] === day) {
          newValue.splice(i, 1);
        }
      }
    } else {
      newValue.push(day);
      newValue = newValue.sort((a, b) => a - b);
    }
    this.setState({ alertDays: newValue });
  }

  onPressPause = () => {
    this.setState({ alertEnabled: !this.state.alertEnabled });
  };

  onPressDeleteAccount = () => {
    Analytics.logEvent(Events.CLICK_DELETE_ACCOUNT);

    this.setState({ deleteModalOpen: true });
  };

  getAlertStartingAtForModal() {
    return moment(this.state.alertStartingAt, 'HH:mm').toDate();
  }

  getAlertUntilForModal() {
    return moment(this.state.alertEndingAt, 'HH:mm').toDate();
  }

  getAlertStartingAtText() {
    return moment(this.state.alertStartingAt, 'HH:mm').format('h.mm A');
  }

  getAlertEndingAtText() {
    return moment(this.state.alertEndingAt, 'HH:mm').format('h.mm A');
  }

  getAlertIntervalText() {
    if (this.state.alertInterval === Constant.ALERT_INTERVAL_HOURLY) {
      return Strings.SETTINGS.hourly;
    } else if (this.state.alertInterval === Constant.ALERT_INTERVAL_BI_HOURLY) {
      return Strings.SETTINGS.biHourly;
    } else if (
      this.state.alertInterval === Constant.ALERT_INTERVAL_TWICE_PER_DAY
    ) {
      return Strings.SETTINGS.twicePerDay;
    } else if (
      this.state.alertInterval === Constant.ALERT_INTERVAL_END_OF_DAY
    ) {
      return Strings.SETTINGS.endOfDay;
    }

    return '';
  }

  getPauseText() {
    if (this.state.alertEnabled) {
      return Strings.SETTINGS.pauseNotifications;
    }
    return Strings.SETTINGS.resumeNotifications;
  }

  doDeleteAccount = () => {
    const { dispatch } = this.props;
    dispatch(userActions.deleteAccount(this.state.password));
  };

  applyChanges = () => {
    const name = this.state.displayName;
    const nameChanged = this.props.displayName !== name && name.length > 0;
    const { dispatch } = this.props;
    const user = {
      displayName: this.state.displayName,
      settings: {
        alertDays: this.state.alertDays,
        alertInterval: this.state.alertInterval,
        alertStartingAt: this.state.alertStartingAt,
        alertEndingAt: this.state.alertEndingAt,
        alertEnabled: this.state.alertEnabled,
        alertIncrementMinutes: this.state.alertIncrementMinutes,
        defaultCurrency: this.state.defaultCurrency,
      },
    };
    dispatch(userActions.updateSettings(user, nameChanged));
  };

  isDaySelected(day) {
    return this.state.alertDays.indexOf(day) !== -1;
  }

  changeBugMe = (e, { value }) => {
    this.setState({ alertInterval: value });
  };

  changeCurrency = (e, { value }) => {
    this.setState({ defaultCurrency: value });
  };

  changeAlertStartingAt = time => {
    this.setState({ alertStartingAt: moment(time).format('HH:mm') });
  };

  changeAlertUntil = time => {
    this.setState({ alertEndingAt: moment(time).format('HH:mm') });
  };

  changeIncrement = (e, { value }) => {
    this.setState({ alertIncrementMinutes: value });
  };

  renderTimePickerModal() {
    return (
      <div>
        <Modal
          centered
          open={this.state.startingAtOpen}
          basic
          size="mini"
          onClose={() => this.setState({ startingAtOpen: false })}
        >
          <Modal.Content>
            <div>
              <TimePicker
                mode="12h"
                onChange={this.changeAlertStartingAt}
                value={this.getAlertStartingAtForModal()}
              />
              <button
                className="time-picker-modal-done"
                onClick={() => this.setState({ startingAtOpen: false })}
              >
                {Strings.COMMON.done.toUpperCase()}
              </button>
            </div>
          </Modal.Content>
        </Modal>
        <Modal
          centered
          open={this.state.untilOpen}
          basic
          size="mini"
          onClose={() => this.setState({ untilOpen: false })}
        >
          <Modal.Content>
            <div>
              <TimePicker
                mode="12h"
                onChange={this.changeAlertUntil}
                value={this.getAlertUntilForModal()}
              />
              <button
                className="time-picker-modal-done"
                onClick={() => this.setState({ untilOpen: false })}
              >
                {Strings.COMMON.done.toUpperCase()}
              </button>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    );
  }

  renderDeleteAccountModal() {
    const { dispatch } = this.props;
    const visible = this.props.deleteAccountError.length > 0;
    return (
      <Modal
        centered
        open={this.state.deleteModalOpen}
        size="mini"
        closeOnDimmerClick={!this.props.deletingAccount}
        closeIcon
        onClose={() => {
          dispatch(userActions.resetDeleteAccountError());
          this.setState({
            deleteModalOpen: false,
            password: '',
          });
        }}
      >
        <Modal.Content>
          <div className="common-modal-root">
            <Image id="bomb-emoji" src="/emoji/bomb.svg" />
            <p className="common-modal-title">
              {Strings.SETTINGS.deleteAccountPromptTitle}
            </p>
            <p className="common-modal-body">
              {Strings.SETTINGS.deleteAccountPromptBody}
            </p>
            <Transition visible={visible} animation="fade" duration={500}>
              <p id="modal-error-text" className="delete-account-error">
                {this.props.deleteAccountError}
              </p>
            </Transition>
            <Input
              id="delete-account-password-input"
              placeholder={Strings.LOGIN.passwordHint}
              name="password"
              value={this.state.password}
              type="password"
              onChange={(e, { value }) => this.setState({ password: value })}
            />
            <Button
              id="modal-delete-account-button"
              className="common-modal-negative-button"
              onClick={this.doDeleteAccount}
              disabled={!this.state.password}
              loading={this.props.deletingAccount}
            >
              {Strings.COMMON.submit}
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    );
  }

  render() {
    const fieldsChanged =
      this.state.displayName !== this.props.displayName ||
      this.state.alertInterval !== this.props.alertInterval ||
      !SettingsProfile.arraysEqual(
        this.state.alertDays,
        this.props.alertDays,
      ) ||
      this.state.alertStartingAt !== this.props.alertStartingAt ||
      this.state.alertEndingAt !== this.props.alertEndingAt ||
      this.state.alertEnabled !== this.props.alertEnabled ||
      this.state.alertIncrementMinutes !== this.props.alertIncrementMinutes ||
      this.state.defaultCurrency !== this.props.defaultCurrency;
    const applyButtonClassName = fieldsChanged
      ? 'common-green-button'
      : 'profile-apply-changes';
    return (
      <div className="profile-root">
        {this.renderTimePickerModal()}
        {this.renderDeleteAccountModal()}
        <Segment basic className="profile-content">
          <Dimmer active={this.props.loading} inverted>
            <Loader inverted />
          </Dimmer>
          <div className="profile-title-container">
            <h1 id="profile-title-text" className="profile-title">
              {Strings.SETTINGS.yourInformation}
            </h1>
            <Button
              id="apply-changes-button"
              className={applyButtonClassName}
              disabled={!fieldsChanged}
              onClick={this.applyChanges}
            >
              {Strings.SETTINGS.applyChanges}
            </Button>
          </div>
          <Input
            id="profile-user-name-input"
            type="text"
            placeholder={this.props.displayName}
            defaultValue={this.props.displayName}
            onChange={this.onNameInput}
          />
          <div className="profile-name-line" />
          <p id="profile-user-email-text" className="profile-email">
            {this.props.email}
          </p>
          <div id="bug-me-container" className="profile-bug-me">
            <p id="bug-me-text" className="profile-bug-me-text">
              {Strings.SETTINGS.bugMeTitle}
            </p>
            <Dropdown
              text={this.getAlertIntervalText()}
              basic
              className="profile-drop-down"
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  value={Constant.ALERT_INTERVAL_HOURLY}
                  onClick={this.changeBugMe}
                  className="profile-drop-down-item"
                >
                  {Strings.SETTINGS.hourly}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Constant.ALERT_INTERVAL_BI_HOURLY}
                  onClick={this.changeBugMe}
                  className="profile-drop-down-item"
                >
                  {Strings.SETTINGS.biHourly}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Constant.ALERT_INTERVAL_TWICE_PER_DAY}
                  onClick={this.changeBugMe}
                  className="profile-drop-down-item"
                >
                  {Strings.SETTINGS.twicePerDay}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Constant.ALERT_INTERVAL_END_OF_DAY}
                  onClick={this.changeBugMe}
                  className="profile-drop-down-item"
                >
                  {Strings.SETTINGS.endOfDay}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div id="day-container" className="profile-day">
            <p id="day-text" className="profile-day-text">
              {Strings.SETTINGS.daysTitle}
            </p>
            <div className="profile-day-options">
              <DayOption
                id="sunday-button"
                label="S"
                active={this.isDaySelected(0)}
                onClick={() => this.onPressDay(0)}
              />
              <DayOption
                id="monday-button"
                label="M"
                active={this.isDaySelected(1)}
                onClick={() => this.onPressDay(1)}
              />
              <DayOption
                id="tuesday-button"
                label="T"
                active={this.isDaySelected(2)}
                onClick={() => this.onPressDay(2)}
              />
              <DayOption
                id="wednesday-button"
                label="W"
                active={this.isDaySelected(3)}
                onClick={() => this.onPressDay(3)}
              />
              <DayOption
                id="thursday-button"
                label="T"
                active={this.isDaySelected(4)}
                onClick={() => this.onPressDay(4)}
              />
              <DayOption
                id="friday-button"
                label="F"
                active={this.isDaySelected(5)}
                onClick={() => this.onPressDay(5)}
              />
              <DayOption
                id="saturday-button"
                label="S"
                active={this.isDaySelected(6)}
                onClick={() => this.onPressDay(6)}
              />
            </div>
          </div>
          <div className="profile-time-container">
            <div id="starting-at-container" className="profile-bug-me">
              <p id="starting-at-text" className="profile-bug-me-text">
                {Strings.SETTINGS.startingTitle}
              </p>
              {/* We use Dropdown here to achieve same visual than for actual Dropdowns */}
              <Dropdown
                text={this.getAlertStartingAtText()}
                basic
                className="profile-drop-down"
                onClick={() => this.setState({ startingAtOpen: true })}
              >
                <Dropdown.Menu className="profile-drop-down-hidden" />
              </Dropdown>
            </div>
            <div className="profile-space" />
            <div id="until-container" className="profile-bug-me">
              <p id="until-text" className="profile-bug-me-text">
                {Strings.SETTINGS.untilTitle}
              </p>
              {/* We use Dropdown here to achieve same visual than for actual Dropdowns */}
              <Dropdown
                text={this.getAlertEndingAtText()}
                basic
                className="profile-drop-down"
                onClick={() => this.setState({ untilOpen: true })}
              >
                <Dropdown.Menu className="profile-drop-down-hidden" />
              </Dropdown>
            </div>
          </div>
          <button
            id="pause-notifications-button"
            className="profile-apply-changes"
            onClick={this.onPressPause}
          >
            {this.getPauseText()}
          </button>
          <div id="increment-container" className="profile-bug-me">
            <p id="increment-text" className="profile-bug-me-text">
              {Strings.SETTINGS.incrementTitle}
            </p>
            <Dropdown
              text={SettingsProfile.getIncrementText(
                this.state.alertIncrementMinutes,
              )}
              basic
              className="profile-drop-down"
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  value={5}
                  onClick={this.changeIncrement}
                  className="profile-drop-down-item"
                >
                  {Strings.SETTINGS.increment5Minutes}
                </Dropdown.Item>
                <Dropdown.Item
                  value={15}
                  onClick={this.changeIncrement}
                  className="profile-drop-down-item"
                >
                  {Strings.SETTINGS.increment15Minutes}
                </Dropdown.Item>
                <Dropdown.Item
                  value={30}
                  onClick={this.changeIncrement}
                  className="profile-drop-down-item"
                >
                  {Strings.SETTINGS.increment30Minutes}
                </Dropdown.Item>
                <Dropdown.Item
                  value={60}
                  onClick={this.changeIncrement}
                  className="profile-drop-down-item"
                >
                  {Strings.SETTINGS.increment60Minutes}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div id="currency-container" className="profile-bug-me">
            <p id="currency-text" className="profile-bug-me-text">
              {Strings.SETTINGS.defaultCurrencyTitle}
            </p>
            <Dropdown
              text={getCurrencyText(this.state.defaultCurrency)}
              basic
              className="profile-drop-down"
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  value={Strings.CURRENCIES.dollarCode}
                  onClick={this.changeCurrency}
                  className="profile-drop-down-item"
                >
                  {Strings.CURRENCIES.dollar}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.euroCode}
                  onClick={this.changeCurrency}
                  className="profile-drop-down-item"
                >
                  {Strings.CURRENCIES.euro}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.yenCode}
                  onClick={this.changeCurrency}
                  className="profile-drop-down-item"
                >
                  {Strings.CURRENCIES.yen}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.poundCode}
                  onClick={this.changeCurrency}
                  className="profile-drop-down-item"
                >
                  {Strings.CURRENCIES.pound}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.rubleCode}
                  onClick={this.changeCurrency}
                  className="profile-drop-down-item"
                >
                  {Strings.CURRENCIES.ruble}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.rupeeCode}
                  onClick={this.changeCurrency}
                  className="profile-drop-down-item"
                >
                  {Strings.CURRENCIES.rupee}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.rialCode}
                  onClick={this.changeCurrency}
                  className="profile-drop-down-item"
                >
                  {Strings.CURRENCIES.rial}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <button
            id="delete-account-button"
            className="profile-delete-account"
            onClick={this.onPressDeleteAccount}
          >
            {Strings.SETTINGS.deleteAccount}
          </button>
        </Segment>
      </div>
    );
  }
}

SettingsProfile.propTypes = {
  dispatch: PropTypes.func.isRequired,
  displayName: PropTypes.string,
  email: PropTypes.string,
  alertInterval: PropTypes.string,
  alertDays: PropTypes.arrayOf(PropTypes.number),
  alertStartingAt: PropTypes.string,
  alertEndingAt: PropTypes.string,
  alertEnabled: PropTypes.bool,
  alertIncrementMinutes: PropTypes.number,
  defaultCurrency: PropTypes.string,
  loading: PropTypes.bool,
  deletingAccount: PropTypes.bool,
  deleteAccountError: PropTypes.string,
};

SettingsProfile.defaultProps = {
  displayName: '',
  email: '',
  alertInterval: Constant.ALERT_INTERVAL_HOURLY,
  alertDays: Constant.DEFAULT_ALERT_DAYS,
  alertStartingAt: Constant.DEFAULT_ALERT_STARTING_AT,
  alertEndingAt: Constant.DEFAULT_ALERT_ENDING_AT,
  alertEnabled: Constant.DEFAULT_ALERT_ENABLED,
  alertIncrementMinutes: Constant.DEFAULT_ALERT_INCREMENT_MINUTES,
  defaultCurrency: Constant.DEFAULT_CURRENCY_CODE,
  loading: false,
  deletingAccount: false,
  deleteAccountError: '',
};

const mapStateToProps = state => ({
  displayName: state.user.displayName,
  email: state.user.email,
  alertInterval: state.user.settings.alertInterval,
  alertDays: state.user.settings.alertDays.asMutable(),
  alertStartingAt: state.user.settings.alertStartingAt,
  alertEndingAt: state.user.settings.alertEndingAt,
  alertEnabled: state.user.settings.alertEnabled,
  alertIncrementMinutes: state.user.settings.alertIncrementMinutes,
  defaultCurrency: state.user.settings.defaultCurrency,
  loading: state.uiState.isUserLoading,
  deletingAccount: state.uiState.isDeletingAccount,
  deleteAccountError: state.uiState.deleteAccountError,
});

export default connect(mapStateToProps)(SettingsProfile);



// WEBPACK FOOTER //
// ./src/components/settings/SettingsProfile.js